export default __webpack_public_path__ + "static/media/2018-02-05-06-26-25-d0c746.48e38f12.png";